import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { Observable } from 'rxjs';
import { ResourceListDtRetInfo } from './DTOs/resource-list-dt-ret-info';
import { GetResourceListRequest } from './DTOs/get-resource-list-request';
import { ResourcePageDetails } from './DTOs/resource-page-details';
import { CreateResourceRequest } from './DTOs/create-resource-request';
import { UpdateResourcePageRequest } from './DTOs/update-resource-page-request';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminResourcesService {
    readonly relativeBase = "super-admin-resources/";

    constructor(private http: ApiClient) { }

    getResourcesList(request: GetResourceListRequest): Observable<ResourceListDtRetInfo> {
        return this.http.post(this.relativeBase + "get-resource-list", request);
    }
    getResourcePageDetails(id: number): Observable<ResourcePageDetails> {
        return this.http.get(this.relativeBase + "get-resource-page-details/" + id);
    }
    createResourcePage(request: CreateResourceRequest) {
        return this.http.post(this.relativeBase + "create", request);
    }
    uploadFiles(formData: FormData) {
        return this.http.post(this.relativeBase + "upload", formData);
    }
    updateResourcePage(req: UpdateResourcePageRequest) {
        return this.http.post(this.relativeBase + "update", req);
    }
    uploadInsertedImage(formData: FormData) {
        return this.http.post(this.relativeBase + "upload-inserted-image", formData);
    }

}
